import { render, staticRenderFns } from "./pbbadjustfrm.vue?vue&type=template&id=70ae6ef2"
import script from "./pbbadjustfrm.vue?vue&type=script&lang=js"
export * from "./pbbadjustfrm.vue?vue&type=script&lang=js"
import style0 from "./pbbadjustfrm.vue?vue&type=style&index=0&id=70ae6ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports